import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes, useNavigate } from 'react-router'

import { QuoteManagementConfig } from '../../../../../state/configuration'
import { AppPath } from '../../../../AppPath'
import { PolicyAdjustmentResultRouter } from '../results'
import { PolicyAdjustmentPage } from './PolicyAdjustmentPage'
import { PolicyAdjustmentPath } from './PolicyAdjustmentPath'

export interface PolicyAdjustmentRouterProps {
  config: QuoteManagementConfig
}

export const PolicyAdjustmentRouter: FunctionComponent<PolicyAdjustmentRouterProps> = ({
  config,
}) => {
  const navigate = useNavigate()

  return (
    <Routes>
      <Route index element={<PolicyAdjustmentPage config={config} />} />
      <Route
        path={PolicyAdjustmentPath.Adjustment + AppPath.WILDCARD}
        element={
          <PolicyAdjustmentResultRouter
            config={config}
            onComplete={() => navigate('../..')}
            onRepeat={() => navigate('..')}
          />
        }
      />
      <Route path='*' element={<Navigate to='..' />} />
    </Routes>
  )
}
